/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */
export const MENU = {
	key: 'quick-insert-menu',
	type: 'menu',
} as const;

export const RECOMMENDED_SECTION = {
	key: 'quick-insert-recommended-section',
	type: 'menu-section',
} as const;

export const STRUCTURE_SECTION = {
	key: 'quick-insert-structure-section',
	type: 'menu-section',
} as const;

export const MEDIA_SECTION = {
	key: 'quick-insert-media-section',
	type: 'menu-section',
} as const;

export const EMBED_SECTION = {
	key: 'quick-insert-embed-section',
	type: 'menu-section',
} as const;

export const TEXT_FORMATTING_SECTION = {
	key: 'quick-insert-text-formatting-section',
	type: 'menu-section',
} as const;

export const ROVO_SECTION = {
	key: 'quick-insert-rovo-section',
	type: 'menu-section',
} as const;

export const DATA_AND_CHARTS_SECTION = {
	key: 'quick-insert-data-and-charts-section',
	type: 'menu-section',
} as const;

export const BLOCK_TEMPLATES_SECTION = {
	key: 'quick-insert-block-templates-section',
	type: 'menu-section',
} as const;

export const OTHER_SECTION = {
	key: 'quick-insert-other-section',
	type: 'menu-section',
} as const;

export const VIEW_ALL_ELEMENTS_MENU_ITEM = {
	key: 'quick-insert-view-all-elements-menu-item',
	type: 'menu-item',
} as const;

export const ACTION_MENU_ITEM = {
	key: 'quick-insert-action-menu-item',
	type: 'menu-item',
} as const;

export const TABLE_MENU_ITEM = {
	key: 'quick-insert-table-menu-item',
	type: 'menu-item',
} as const;

export const STATUS_MENU_ITEM = {
	key: 'quick-insert-status-menu-item',
	type: 'menu-item',
} as const;

export const DATE_MENU_ITEM = {
	key: 'quick-insert-date-menu-item',
	type: 'menu-item',
} as const;

export const SYNCED_BLOCK_MENU_ITEM = {
	key: 'quick-insert-synced-block-menu-item',
	type: 'menu-item',
} as const;

export const EXPAND_MENU_ITEM = {
	key: 'quick-insert-expand-menu-item',
	type: 'menu-item',
} as const;

export const DECISION_MENU_ITEM = {
	key: 'quick-insert-decision-menu-item',
	type: 'menu-item',
} as const;

export const INFO_PANEL_MENU_ITEM = {
	key: 'quick-insert-info-panel-menu-item',
	type: 'menu-item',
} as const;

export const NOTE_PANEL_MENU_ITEM = {
	key: 'quick-insert-note-panel-menu-item',
	type: 'menu-item',
} as const;

export const SUCCESS_PANEL_MENU_ITEM = {
	key: 'quick-insert-success-panel-menu-item',
	type: 'menu-item',
} as const;

export const WARNING_PANEL_MENU_ITEM = {
	key: 'quick-insert-warning-panel-menu-item',
	type: 'menu-item',
} as const;

export const ERROR_PANEL_MENU_ITEM = {
	key: 'quick-insert-error-panel-menu-item',
	type: 'menu-item',
} as const;

export const CUSTOM_PANEL_MENU_ITEM = {
	key: 'quick-insert-custom-panel-menu-item',
	type: 'menu-item',
} as const;

export const TWO_COLUMNS_LAYOUT_MENU_ITEM = {
	key: 'quick-insert-two-columns-layout-menu-item',
	type: 'menu-item',
} as const;

export const THREE_COLUMNS_LAYOUT_MENU_ITEM = {
	key: 'quick-insert-three-columns-layout-menu-item',
	type: 'menu-item',
} as const;

export const FOUR_COLUMNS_LAYOUT_MENU_ITEM = {
	key: 'quick-insert-four-columns-layout-menu-item',
	type: 'menu-item',
} as const;

export const FIVE_COLUMNS_LAYOUT_MENU_ITEM = {
	key: 'quick-insert-five-columns-layout-menu-item',
	type: 'menu-item',
} as const;

export const MEDIA_INSERT_MENU_ITEM = {
	key: 'quick-insert-media-insert-menu-item',
	type: 'menu-item',
} as const;

export const HYPERLINK_MENU_ITEM = {
	key: 'quick-insert-hyperlink-menu-item',
	type: 'menu-item',
} as const;

export const EMOJI_MENU_ITEM = {
	key: 'quick-insert-emoji-menu-item',
	type: 'menu-item',
} as const;

export const LOOM_MENU_ITEM = {
	key: 'quick-insert-loom-menu-item',
	type: 'menu-item',
} as const;

export const MENTION_MENU_ITEM = {
	key: 'quick-insert-mention-menu-item',
	type: 'menu-item',
} as const;

export const AI_IMAGE_GENERATION_MENU_ITEM = {
	key: 'quick-insert-ai-image-generation-menu-item',
	type: 'menu-item',
} as const;

export const HEADING_1_MENU_ITEM = {
	key: 'quick-insert-heading-1-menu-item',
	type: 'menu-item',
} as const;

export const HEADING_2_MENU_ITEM = {
	key: 'quick-insert-heading-2-menu-item',
	type: 'menu-item',
} as const;

export const HEADING_3_MENU_ITEM = {
	key: 'quick-insert-heading-3-menu-item',
	type: 'menu-item',
} as const;

export const HEADING_4_MENU_ITEM = {
	key: 'quick-insert-heading-4-menu-item',
	type: 'menu-item',
} as const;

export const HEADING_5_MENU_ITEM = {
	key: 'quick-insert-heading-5-menu-item',
	type: 'menu-item',
} as const;

export const HEADING_6_MENU_ITEM = {
	key: 'quick-insert-heading-6-menu-item',
	type: 'menu-item',
} as const;

export const BLOCKQUOTE_MENU_ITEM = {
	key: 'quick-insert-blockquote-menu-item',
	type: 'menu-item',
} as const;

export const CODE_BLOCK_MENU_ITEM = {
	key: 'quick-insert-code-block-menu-item',
	type: 'menu-item',
} as const;

export const RULE_MENU_ITEM = {
	key: 'quick-insert-rule-menu-item',
	type: 'menu-item',
} as const;

export const PLACEHOLDER_TEXT_MENU_ITEM = {
	key: 'quick-insert-placeholder-text-menu-item',
	type: 'menu-item',
} as const;

export const UNORDERED_LIST_MENU_ITEM = {
	key: 'quick-insert-unordered-list-menu-item',
	type: 'menu-item',
} as const;

export const ORDERED_LIST_MENU_ITEM = {
	key: 'quick-insert-ordered-list-menu-item',
	type: 'menu-item',
} as const;

export const ASK_ROVO_MENU_ITEM = {
	key: 'quick-insert-ask-rovo-menu-item',
	type: 'menu-item',
} as const;

export const JIRA_WORK_ITEMS_MENU_ITEM = {
	key: 'quick-insert-jira-work-items-menu-item',
	type: 'menu-item',
} as const;

export const ASSETS_MENU_ITEM = {
	key: 'quick-insert-assets-menu-item',
	type: 'menu-item',
} as const;

export const CONFLUENCE_LIST_MENU_ITEM = {
	key: 'quick-insert-confluence-list-menu-item',
	type: 'menu-item',
} as const;

export const HELP_DIALOG_MENU_ITEM = {
	key: 'quick-insert-help-dialog-menu-item',
	type: 'menu-item',
} as const;

export const getBlockTemplateMenuItem = (
	id: string,
): { readonly key: string; readonly type: 'menu-item' } => ({
	key: `quick-insert-block-template-${id}`,
	type: 'menu-item',
});
